import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('rect', { width: '32', height: '32', fill: '#fff' }),
  React.createElement('path', {
    d: 'M6.672.6,0,6.956,1.251,8.147,7.3,2.379V17.7H9.07V2.379l6.052,5.768,1.251-1.191L9.7.6A2.22,2.22,0,0,0,6.672.6Z',
    transform: 'translate(25.021 8.131) rotate(90)'
  })
));